import React from 'react';
import ConsentFormPage from "./ConsentFormPage";
import GrievanceFormPdfContent from "./GrievanceFormPdfContent";
import ConfidentialityPolicy from './ConfidentialityPolicy';
import DischargePolicyPage from './DischargePolicyPage';
import DischargeTypesPage from './generateDischargeTypesPage';
import DrugTestingPolicyPage from './generateDrugTestingPolicyPage';
import EmergencyPolicyPage from './generateEmergencyPolicyPage';
import GoodNeighborPolicyPage from './generateGoodNeighborPolicyPage';
import ProgramFormatHouseRulesPage from './generateProgramFormatHouseRulesPage';
import ProhibitedMedicationsPage from './generateProhibitedMedicationsPage';
import {ReoccurrencePolicyPage,MaintenancePolicyPage} from './ReoccurrencePolicyPage'
import HazardousItemsPolicyPage from './generateHazardousItemsPolicyPage'
import ReleaseFormsPage from './generateReleaseFormsPage'
import ProgramRulesPage from './generateProgramRulesPage'
import Phase1ResidenceRules from './generatePhase1ResidenceRules'
import Phase2ResidenceRules from './Phase2ResidenceRules'
import PrimaryProgramLease from './generatePrimaryProgramLease'
import LeaseApplicationPreview from './LeaseApplicationPreview';
import HousingIntakeForm from './generateHousingIntakeForm';
import ConsentReleaseForm from "./generateConsentReleaseForm";
import BillOfRights from "./generateBillOfRights";
import BelongingsForm from "./generateBelongingsForm";

const Allfiles = ({ data,signatureData,staffSignatureData }) => {

  const currentDate = new Date().toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });


const consentData = {
    // Personal information (unchanged)
    firstName: data?.personalContact?.firstName,
    lastName: data?.personalContact?.lastName,
    clientName: `${data?.personalContact?.firstName} ${data?.personalContact?.lastName}`,
    dob: data?.personalContact?.dob,
    ssnLast4: data?.personalContact?.ssnLast4,
  
    // Disclosure/obtain toggles (mapped from formData)
    discloseTo: data?.residencySponsor?.disclosePresence || data?.residencySponsor?.discloseMedicalHistory || data?.residencySponsor?.discloseProgress || data?.residencySponsor?.discloseAssessment || data?.residencySponsor?.discloseAftercare || data?.residencySponsor?.discloseDischarge,
    obtainFrom: data?.residencySponsor?.obtainTreatmentPlans || data?.residencySponsor?.obtainLabResults || data?.residencySponsor?.obtainPsychAssessment || data?.residencySponsor?.obtainDischargeSummary || data?.residencySponsor?.obtainEmploymentInfo,
  
    // Information disclosure fields (mapped from formData)
    infoPresence: data?.residencySponsor?.disclosePresence,
    infoMedical: data?.residencySponsor?.discloseMedicalHistory,
    infoProgress: data?.residencySponsor?.discloseProgress,
    infoAssessment: data?.residencySponsor?.discloseAssessment,
    infoAftercare: data?.residencySponsor?.discloseAftercare,
    infoDischarge: data?.residencySponsor?.discloseDischarge,
    infoTreatment: data?.residencySponsor?.obtainTreatmentPlans,
    infoLab: data?.residencySponsor?.obtainLabResults,
    infoPsych: data?.residencySponsor?.obtainPsychAssessment,
    infoSummary: data?.residencySponsor?.obtainDischargeSummary,
    infoEmployment: data?.residencySponsor?.obtainEmploymentInfo,
    
    // Medical/legal info (unchanged)
    infoPsychHistory: data?.medicalLegal?.mentalHealthCondition === true,
    infoLegal: data?.medicalLegal?.legalCases === true,
    infoPhysical: data?.medicalLegal?.physicalLimitations === true,
    
    // Other information (mapped from formData)
    infoOther: data?.residencySponsor?.otherInfoDetails,
    infoOtherChecked: data?.residencySponsor?.otherInfoChecked,
    infoFamily: false, // Default false unless you have a field for this
  
    // Communication methods (mapped from formData)
    methodElectronic: data?.residencySponsor?.commElectronic,
    methodOral: data?.residencySponsor?.commOral,
    methodWritten: data?.residencySponsor?.commWritten,

    reasonEmergency: !!data?.personalContact?.emergencyContact?.name,
    reasonCourt: data?.medicalLegal?.legalCases === true || data?.medicalLegal?.probationStatus === true,
    reasonContinuity: data?.residencySponsor?.reasonContinuity ?? false,
    reasonHistory: data?.residencySponsor?.reasonHistory ?? false,
    reasonEmergency: data?.residencySponsor?.reasonEmergency ?? false,
    reasonCourtLegal: data?.residencySponsor?.reasonCourtLegal ?? false,
    reasonEmployment: data?.residencySponsor?.reasonEmployment ?? false,
    reasonOtherChecked: data?.residencySponsor?.reasonOtherChecked ?? false,
    reasonOtherDetails: "",
  
    // Metadata
    date: new Date().toLocaleDateString(),
};
  
  

const belongingsData = {
    firstName: data?.personalContact?.firstName || "",
    lastName: data?.personalContact?.lastName || "",
    belongingsDate: data?.date || new Date().toISOString().split("T")[0],
    hasAdditionalItems: data?.belongingsDevices?.hasItemsToStore || false,
    additionalItemsDetails: data?.belongingsDevices?.storedItems?.otherDetails || "",
    driversLicense: data?.belongingsDevices?.storedItems?.driversLicense || false,
    insuranceCards: data?.belongingsDevices?.storedItems?.insuranceCard || false,
    otherIDs: data?.belongingsDevices?.storedItems?.governmentID || false,
    cashAmount: data?.belongingsDevices?.cashAmount || 0,
    wallet: data?.belongingsDevices?.storedItems?.wallet || false,
    blankChecks: data?.belongingsDevices?.storedItems?.bankChecks || false,
    writtenChecks: false, // Default false as not in original data
    creditDebitCards: data?.belongingsDevices?.storedItems?.creditDebitCards || false,
    device1: data?.belongingsDevices?.devices?.[0]?.type || "",
    device1Charger: data?.belongingsDevices?.devices?.[0]?.hasCharger ? "Y" : "N",
    device1Condition: data?.belongingsDevices?.devices?.[0]?.condition || "",
    device2: data?.belongingsDevices?.devices?.[1]?.type || "",
    device2Charger: data?.belongingsDevices?.devices?.[1]?.hasCharger ? "Y" : "N",
    device2Condition: data?.belongingsDevices?.devices?.[1]?.condition || "",
    device3: data?.belongingsDevices?.devices?.[2]?.type || "",
    device3Charger: data?.belongingsDevices?.devices?.[2]?.hasCharger ? "Y" : "N",
    device3Condition: data?.belongingsDevices?.devices?.[2]?.condition || "",
    notes: data?.belongingsDevices?.specialInstructions || "",
    sharps: data?.belongingsDevices?.restrictedItemsList || "",
    otherItems: data?.belongingsDevices?.storedItems?.other || "",
    date: data?.date || new Date().toISOString().split("T")[0],
    completionDate: new Date().toLocaleDateString(),
    completedBy: `${data?.medicalLegal?.staffFirstName || ""} ${data?.medicalLegal?.staffLastName || ""}`.trim() || "Not specified",
    location: data?.residencySponsor?.location || "Legacy Healing Margate",
    cardType: data?.belongingsDevices?.cardType ?? "",
    cardNumber: data?.belongingsDevices?.cardNumber ?? "",
};
  
  return (
  
    <>
    <ConsentFormPage data={data} signatureData={signatureData} staffSignatureData={staffSignatureData} />
    <GrievanceFormPdfContent />
    <ConfidentialityPolicy />
    <DischargePolicyPage />
    <DischargeTypesPage />
    <DrugTestingPolicyPage signatureData={signatureData} staffSignatureData={staffSignatureData} currentDate={currentDate}/>
    <EmergencyPolicyPage />
    <GoodNeighborPolicyPage />
    <ProgramFormatHouseRulesPage />
    <ProhibitedMedicationsPage />
    <ReoccurrencePolicyPage signatureData={signatureData}/>
    <MaintenancePolicyPage signatureData={signatureData}/>
    <HazardousItemsPolicyPage signatureData={signatureData}/>
    <ReleaseFormsPage data={data} signatureData={signatureData} staffSignatureData={staffSignatureData} currentDate={currentDate}/>
    <ProgramRulesPage signatureData={signatureData} staffSignatureData={staffSignatureData} currentDate={currentDate}/>
    <Phase1ResidenceRules signatureData={signatureData} staffSignatureData={staffSignatureData} currentDate={currentDate}/>
    <Phase2ResidenceRules data={data} signatureData={signatureData} staffSignatureData={staffSignatureData} currentDate={currentDate}/>
    <PrimaryProgramLease data={data} signatureData={signatureData} staffSignatureData={staffSignatureData} currentDate={currentDate}/>
    <LeaseApplicationPreview data={data} signatureData={signatureData} currentDate={currentDate}/>
    <HousingIntakeForm data={data} signatureData={signatureData} currentDate={currentDate}/>
    <ConsentReleaseForm data={consentData} signatureData={signatureData} currentDate={currentDate}/>
    <BillOfRights data={data}/>
    <BelongingsForm data={belongingsData} signatureData={signatureData} currentDate={currentDate}/>
    </>
  );
};

export default Allfiles;